import {
  isRiskInsurance,
  isStorebrandHealthProviderInsurance,
  isStorebrandLifeProviderInsurance,
} from "Store/interfaces/products";

import CollapsibleContainer from "Components/CollapsibleContainer";
import { insuranceNameToProductBackendName } from "Components/Features/CheckPrice/Products/utils";
import { InsuranceTermsPdfButtons } from "Components/InsuranceTermsPdfButtons";
import { IpidPdfButtons } from "Components/IpidPdfButtons";
import { useTexts } from "Components/TextContext";
import { InsuranceProduct } from "Store/interfaces/products/checkout";
import { getFMSProductName } from "Store/texts/helpers/FMSproductName";
import { useProductTexts } from "Store/texts/hooks";
import React from "react";
import { InsuranceProvider } from "./CardFooter/styled";
import { ProductDetailsTable } from "./ProductDetailsTable";
import { ProductDetail } from "./ProductDetailsTable/interface";

interface Props {
  readonly product: InsuranceProduct;
  readonly showDetails: boolean;
  readonly productDetails: ProductDetail[];
}

export const FooterProductDetails = ({
  product,
  showDetails,
  productDetails,
}: Props): React.ReactElement => {
  const [productText, lang] = useProductTexts(getFMSProductName(product.name));
  const productBackendName = insuranceNameToProductBackendName(product.name);
  const { getText } = useTexts();

  return (
    <CollapsibleContainer isOpen={showDetails}>
      <div className="insurance-details-card__footer-details">
        <ProductDetailsTable
          productDetails={productDetails}
          productText={productText}
          lang={lang}
          product={product}
        />
        <IpidPdfButtons
          isOnColoredBackground={true}
          coverage={product.coverageGroup}
        />
        {productBackendName && (
          <InsuranceTermsPdfButtons
            isOnColoredBackground={true}
            productBackendName={productBackendName}
          />
        )}
        {isRiskInsurance(product.name) && (
          <InsuranceProvider>
            {getText("offer.description.riskinsuranceprovider")}
          </InsuranceProvider>
        )}
        {isStorebrandLifeProviderInsurance(product.name) && (
          <InsuranceProvider>
            {getText("offer.description.lifeinsuranceprovider")}
          </InsuranceProvider>
        )}
        {isStorebrandHealthProviderInsurance(product.name) && (
          <InsuranceProvider>
            {getText("offer.description.healthinsuranceproviderergo")}
          </InsuranceProvider>
        )}
      </div>
    </CollapsibleContainer>
  );
};
